module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "px-0",
    attrs: {
      "colspan": "13"
    }
  }, [_c('v-simple-table', [_c('tr', {
    class: _vm.ebene > 1 ? '' : 'grey lighten-' + (1 + _vm.ebene * 2)
  }, [_c('td', {
    staticClass: "pr-4 text-left flex-grow-1",
    style: ('padding-left:' + _vm.ebene * 30 + 'px;'),
    attrs: {
      "colspan": "4"
    }
  }, [_c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "cancel-text": "",
      "return-value": _vm.item.bezeichnung
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "bezeichnung", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "bezeichnung", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Bezeichnung eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.bezeichnung),
            callback: function($$v) {
              _vm.$set(_vm.item, "bezeichnung", $$v)
            },
            expression: "item.bezeichnung"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm.item.bezeichnung) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'einnahmen'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.einnahmen
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "einnahmen", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "einnahmen", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Einnahmen eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.einnahmen),
            callback: function($$v) {
              _vm.$set(_vm.item, "einnahmen", $$v)
            },
            expression: "item.einnahmen"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.einnahmen)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'ausgaben'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.ausgaben
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "ausgaben", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "ausgaben", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ausgaben eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.ausgaben),
            callback: function($$v) {
              _vm.$set(_vm.item, "ausgaben", $$v)
            },
            expression: "item.ausgaben"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.ausgaben)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'istEinnahmen'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.istEinnahmen
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "istEinnahmen", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "istEinnahmen", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ist Einnahmen eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.istEinnahmen),
            callback: function($$v) {
              _vm.$set(_vm.item, "istEinnahmen", $$v)
            },
            expression: "item.istEinnahmen"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.istEinnahmen)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.positionen.length > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(_vm.item, 'istAusgaben'))))]) : _c('v-edit-dialog', {
    attrs: {
      "persistent": "",
      "return-value": _vm.item.istAusgaben
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.item, "istAusgaben", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.item, "istAusgaben", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('v-text-field', {
          attrs: {
            "label": "Ist Ausgaben eintragen",
            "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
            "single-line": ""
          },
          model: {
            value: (_vm.item.istAusgaben),
            callback: function($$v) {
              _vm.$set(_vm.item, "istAusgaben", $$v)
            },
            expression: "item.istAusgaben"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.item.istAusgaben)) + "\n            ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4",
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "140px"
    }
  }, [(_vm.item.istEinnahmen || _vm.item.istAusgaben) ? _c('span', [_vm._v("\n            " + _vm._s(_vm._f("money")(parseFloat(_vm.item.istEinnahmen) - parseFloat(_vm.item.einnahmen) - parseFloat(_vm.item.istAusgaben) + parseFloat(_vm.item.ausgaben))) + "\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.item.positionen.length > 0) ? _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "120px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addGroupRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (_vm.item.positionen.length === 0) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.item.show = !_vm.item.show
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1) : _c('td', {
    staticClass: "px-4 text-right",
    attrs: {
      "width": "120px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addGroupRow(_vm.item)
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteGroupRow(_vm.item, _vm.prop)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]), _vm._v(" "), _vm._l((_vm.item.positionen), function(pos, index) {
    return (_vm.item.show) ? _c('rowWirtschaftsplan', {
      key: index,
      attrs: {
        "parent": _vm.item,
        "ebene": _vm.ebene + 1,
        "item": pos
      }
    }) : _vm._e()
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bcdc7d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/rowWirtschaftsplan.vue
// module id = 775
// module chunks = 15